<template>
  <div :class="['nocontent', { nothing: nothing }, { wsNoNontent: 'no-content' }]">
    <img
      :class="['img', { wsNoNontent: 'no-content-img' }]"
      src="@funcPuzzle/mini_doctor/default/no-content.png"
    />
    <div class="text">{{ title }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    nothing: {
      type: Boolean,
      default: false
    },
    wsNoNontent: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.nocontent {
  text-align: center;
  padding: 4.266667rem 1.28rem 1.28rem 1.28rem;
  .img {
    display: inline-block;
    width: 6.826667rem;
    height: 6.826667rem;
  }
  .text {
    display: block;
    padding: 0.64rem 0;
    font-size: 0.64rem;
    color: #888;
  }
}
.nothing {
  padding-top: 4.266667rem;
  text-align: center;
  .img {
    margin: auto;
    display: block;
    width: 6.826667rem;
    height: 6.826667rem;
  }
  .text {
    margin-top: 4.266667rem;
    display: block;
    padding: 0.64rem 0;
    font-size: 0.64rem;
    color: #888;
  }
}
.no-content {
  width: 100%;
  box-sizing: border-box;
  padding-top: 5.333333rem;
  text-align: center;

  .no-content-img {
    // 772 572
    display: inline-block;
    width: 8.234667rem;
    height: 6.101333rem;
  }
  .text {
    display: block;
    padding: 0.64rem 0;
    font-size: 0.64rem;
    line-height: 24px;
    color: #888;
  }
}
</style>
